import { Component, Inject, OnInit } from '@angular/core';
import { EnvironmentToken } from '../../util';
import { Environment } from '../../typings';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  currentYear: number;

  constructor(@Inject(EnvironmentToken) private environment: Environment) {}

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }

  navigateToUrl(event: any) {
    if (event.target.id === 'application-support') {
      top.location.replace(this.environment.aquentWebsite + '/eos');
    } else if (event.target.id === 'privacy-policy') {
      top.location.replace(this.environment.aquentWebsite + '/privacy-policy');
    }
  }
}
